import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubmissionStateEnum } from '../../../../models/users/enum/submission-state-enum';
import { SubmissionInfoItem } from '../../../../models/shared/submission-info-item';
import { SubmissionDetailComponent } from '../submission-detail-grid/submission-detail/submission-detail.component';

@Component({
  selector: 'app-submission-details-changes',
  templateUrl: './submission-details-changes.component.html',
  styleUrls: ['./submission-details-changes.component.scss'],
  standalone: true,
  imports: [CommonModule, SubmissionDetailComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubmissionDetailsChangesComponent {
  @Input() previousInfo: SubmissionInfoItem[] = [];
  @Input() newInfo: SubmissionInfoItem[] = [];
  @Input() previousInfoDisplayString: string = '';
  @Input() newInfoDisplayString: string = '';

  protected readonly SubmissionStateEnum = SubmissionStateEnum;
}
